import AuthService from 'services/auth/AuthService';

import createElement from '../utils/createElement';

const SCRIPT_ID = 'pi-session-js';
const INPUT_ID = 'pi_user_id';

export function areNodesInjected(global = window) {
  const { document } = global;

  const scriptEl = document.querySelector(`script#${SCRIPT_ID}`);
  const inputEl = document.querySelector(`input#${INPUT_ID}`);

  return Boolean(scriptEl) && Boolean(inputEl);
}

function createSession({ clientId, callback, global = window }) {
  return function onLoadHandler() {
    if (global.piSession) {
      // initialize session
      global.piSession.initialize(clientId, {
        monitorUserActivity: true,
        sessionIdleTimeoutSeconds: 1800,
        sessionIdleTimeoutWarningSeconds: 600,
        useDefaultIdleTimoutWarningPopup: false,
        requireLogin: false,
      });

      global.piSession.login(window.location.href);

      global.piSession.on(window.piSession.LogoutEvent, () => {
        global.piSession.logout();

        // logoutSuccessUrl is a custom redirect URL on logout
        // using the same terminology as IES
        const logoutSuccessUrl = AuthService.build().getLogoutSuccessUrl();
        if (logoutSuccessUrl) {
          window.location.replace(logoutSuccessUrl);
        } else {
          global.piSession.login(window.location.href);
        }
      });

      // execute callback, passing in session ref
      if (callback) {
        callback.call(null, global.piSession);
      }
    }
  };
}

function AuthManager() {
  function init(callback, global = window) {
    const { appConfig, document } = global;

    const _url = `${appConfig.getPILoginURL()}/js/v2/session.js`;
    const _clientId = appConfig.getPIClientID();
    if (!areNodesInjected(global)) {
      const scriptTag = createElement('script', {
        attrs: {
          type: 'text/javascript',
          src: _url,
          id: SCRIPT_ID,
          onload: createSession({
            clientId: _clientId,
            callback,
            global,
          }),
        },
      });

      const inputTag = createElement('input', {
        attrs: {
          type: 'hidden',
          id: INPUT_ID,
        },
      });

      for (const node of [scriptTag, inputTag]) {
        document.head.appendChild(node);
      }
    } else if (callback) {
      callback.call(null, global.piSession);
    }

    return true;
  }

  return {
    init,
  };
}

export default AuthManager();
